import * as Sentry from '@sentry/browser'
import {Vue as VueIntegration} from '@sentry/integrations'
import {Integrations} from '@sentry/tracing'

/**
 * @param {string} dsnUrl
 */
export default (dsnUrl) => ({
    sentry: Sentry,
    install (Vue) {
        if (dsnUrl) {
            Sentry.init({
                release: process.env.VERSION,
                dsn: dsnUrl,
                integrations: [
                    new VueIntegration({Vue, tracing: true, logErrors: true}),
                    new Integrations.BrowserTracing()
                ]
            })
            Vue.mixin({
                beforeCreate () {
                    const vm = this
                    const options = vm.$options
                    if (options.sentry || (options.parent && options.parent.$sentry)) {
                        vm.$sentry = Sentry
                    }
                }
            })
        }
    }
})
